import type { CSSProperties } from "react";

/** Deterministic hue for a client name — same seed algorithm as legacy ClientAvatar flat tint. */
export function hashClientHue(name: string): number {
  let h = 0;
  for (let i = 0; i < name.length; i++) {
    h = (h * 31 + name.charCodeAt(i)) | 0;
  }
  return Math.abs(h) % 360;
}

export function clientInitialsFromName(name: string): string {
  return (
    name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase() ?? "")
      .join("") || "?"
  );
}

/**
 * Client avatar surface — dock-style subtle gradient layered on the existing hue palette.
 * Matches OsDock coloured icons: dark base + soft radial highlight, plus a gentle br gradient.
 */
export function clientAvatarSurfaceStyle(name: string): {
  color: string;
  style: CSSProperties;
} {
  const hue = hashClientHue(name);
  const color = `hsl(${hue}, 70%, 78%)`;
  const base = `hsl(${hue}, 50%, 22%)`;
  const gradientStart = `hsl(${hue}, 55%, 30%)`;
  const gradientMid = `hsl(${hue}, 50%, 22%)`;
  const gradientEnd = `hsl(${hue}, 45%, 16%)`;
  const blob = `hsla(${hue}, 70%, 62%, 0.15)`;

  return {
    color,
    style: {
      backgroundColor: base,
      backgroundImage: [
        `radial-gradient(circle at 20% 30%, ${blob}, transparent 60%)`,
        `linear-gradient(135deg, ${gradientStart} 0%, ${gradientMid} 52%, ${gradientEnd} 100%)`,
      ].join(", "),
    },
  };
}
